import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-loan-mortgage-calculator',
  templateUrl: './loan-mortgage-calculator.component.html',
  styleUrls: ['./loan-mortgage-calculator.component.scss']
})
export class LoanMortgageCaclulatorComponent implements OnInit {
  loanProgramOptions = [
    { value: '30year', label: '30 years' },
    { value: '15year', label: '15 years' }
  ];

  displayedColumns: string[] = ['label', 'value'];

  // Form state
  homePrice: number = 500000;
  downPaymentDollar: number = 100000;
  downPaymentPercent: number = 20;
  interestRate: number = 6.9;
  loanProgram: string = '30year';
  includeTaxes: boolean = true;
  propertyTaxDollar: number = 1780;
  propertyTaxPercent: number = 0.89;
  homeInsurance: number = 840;
  hoa: number = 0;
  monthlyPayment: number = 0;
  fees: any[] = [];

  // Intro text
  mortgageCalcIntro: string = 'Estimate your mortgage payment with taxes, insurance, and HOA. Just enter the price of the home, your down payment, and loan details to calculate your estimated payments and schedule!';

  ngOnInit(): void {
    this.doCalculation();
  }

  doCalculation(): void {
    const principal = this.homePrice - this.downPaymentDollar;
    const interest = this.interestRate / 100 / 12;
    const term = this.loanProgram === '30year' ? 30 : 15;
    const termMonths = term * 12;
    const denominator = (Math.pow(1 + interest, termMonths) - 1) / (interest * Math.pow(1 + interest, termMonths));

    let payment = principal / denominator;
    if (payment < 0) payment = 0;

    let results = [
      { label: 'Principal + Interest', value: payment }
    ];

    if (this.includeTaxes) {
      if (this.propertyTaxDollar > 0) {
        const taxVal = this.propertyTaxDollar / 12;
        results.push({ label: 'Taxes', value: taxVal });
        payment += taxVal;
      }
      if (this.homeInsurance > 0) {
        const insuranceVal = this.homeInsurance / 12;
        results.push({ label: 'Insurance', value: insuranceVal });
        payment += insuranceVal;
      }
    }

    if (this.hoa > 0) {
      results.push({ label: 'Homeowners Association', value: this.hoa });
      payment += this.hoa;
    }

    if (this.downPaymentPercent < 20){
      const mortgageInsurance = principal * .0008;
      results.push({ label: 'Mortgage Insurance', value: mortgageInsurance });
      payment += mortgageInsurance;
    }

    this.fees = results;
    this.monthlyPayment = payment;
  }

  handleHomePriceChange(event: any): void {
    this.doCalculation();
  }

  handleDownPaymentDollarChange(event: any): void {
    if (this.downPaymentDollar > this.homePrice) {
      this.downPaymentDollar = this.homePrice;
      this.downPaymentPercent = 100;
    }
    else {
      this.downPaymentPercent = (this.downPaymentDollar / this.homePrice) * 100
    }

    this.doCalculation();
  }

  handleDownPaymentPercentChange(event: any): void {
    event = event.toString();
    const newNumber = parseFloat(event.replace(/[^0-9.]/g, ''));
    this.downPaymentPercent = newNumber;

    this.downPaymentDollar = (newNumber / 100) * this.homePrice;

    this.doCalculation();
  }

  handleInterestRateChange(event: any): void {
    event = event.toString();
    const newNumber = parseFloat(event.replace(/[^0-9.]/g, ''));
    this.interestRate = newNumber;
    this.interestRate = event.replace(/[^0-9.]/g, '');

    if (newNumber > 100) {
      this.interestRate = 100;
    }

    this.doCalculation();
  }

  handlePropertyTaxPercentChange(event: any): void {
    event = event.toString();
    const newNumber = parseFloat(event.replace(/[^0-9.]/g, ''));
    this.propertyTaxPercent = newNumber;

    // Update Property Tax Dollar Amount
    this.propertyTaxDollar = (newNumber / 100) * this.homePrice;

    this.doCalculation();
  }

  handlePropertyTaxDollarChange(event: any): void {
    event = event.toString();
    const newNumber = parseFloat(event.replace(/[^0-9.]/g, ''));
    this.propertyTaxDollar = newNumber;

    // Update Property Tax Percent
    this.propertyTaxPercent = (newNumber / this.homePrice) * 100;

    this.doCalculation();
  }
}
